module.exports = __webpack_public_path__ + "img/clear_night.3919308b.jpg";